<template>
  <div>
    <div class="search-container">
      <div class="search-overview">
        <ul class="view-type-list">
          <li
            class="view-type-list-item pl-0 all"
            @click="changespotType('all', ['all'], null)"
            id="all"
          >
            <span :class="tab === 'all' ? 'active' : ''">All</span>
          </li>
          <li
            v-for="(optionItem, index) in selectorSpotTypes"
            :key="index"
            class="view-type-list-item"
            @click="changespotType(optionItem.id, optionItem.search, index)"
            :id="optionItem.id"
          >
            <span :class="tab === `${optionItem.id}` ? 'active' : ''"
              >{{ optionItem.label }}
              <span
                class="hidden-sm-and-down"
                v-if="tab === `${optionItem.id}`"
                >with A view</span
              ></span
            >
          </li>
        </ul>
      </div>
      <div class="search-details">
        <div class="filter-container mt-1">
          <div style="width: 100%; position: relative; padding: 0px 20px">
            <div style="display: flex; width: 100%">
              <div class="filter-location">
                <i
                  class="material-icons cursor"
                  @click="$router.go(-1)"
                  style="color: #ffffff; font-size: 20px;"
                  >arrow_back_ios</i
                >
                <span class="location-name" @click="toggleLocations">{{
                  filterLocation
                }}</span>
              </div>
            </div>
            <div
              class="location-dropdown"
              v-if="openLocations"
              @mouseleave="toggleLocations"
            >
              <vue-scroll>
                <ul class="location-list">
                  <li class="location-name">
                    <span>{{ filterLocation }}</span>
                    <i class="material-icons" style="font-size: 20px;padding: 5px 5px 5px 15px" @click="toggleLocations">close</i>
                    </li>
                  <div
                    style="background-color: #979797; width: 100%; height: 1px"
                  ></div>
                  <li @click="setLocation('worldwide')">Worldwide</li>
                  <li @click="setLocation('barcelona')">Barcelona</li>
                  <li @click="setLocation('berlin')">Berlin</li>
                  <li @click="setLocation('copenhagen')">Copenhagen</li>
                  <li @click="setLocation('florence')">Florence</li>
                  <li @click="setLocation('lisbon')">Lisbon</li>
                  <li @click="setLocation('london')">London</li>
                  <li @click="setLocation('los angeles')">Los Angeles</li>
                  <li @click="setLocation('madrid')">Madrid</li>
                  <li @click="setLocation('milan')">Milan</li>
                  <li @click="setLocation('new york')">New York</li>
                  <li @click="setLocation('paris')">Paris</li>
                  <li @click="setLocation('porto')">Porto</li>
                  <li @click="setLocation('rome')">Rome</li>
                  <li @click="setLocation('san francisco')">San Francisco</li>
                </ul>
              </vue-scroll>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      filterLocation: "Worldwide",
      filterViewType: "Everything is better ",
      tab: "all",
      spotTypes: ["all"],
      location: "worldwide",
      openLocations: false,
      selectorSpotTypes: [
        {
          label: "Hotels & Apartments",
          id: "hotel",
          search: ["hotel", "appartments"],
        },
        {
          label: "Bars & Restaurants",
          id: "bar",
          search: ["bars", "restaurant", "reataurants", "bar"],
        },
        {
          label: "Panoramic spots",
          id: "panaromic",
          search: ["all"],
        },
      ],
      filterObject: null,
    };
  },
  mounted() {
    let linkQuery = JSON.parse(JSON.stringify(this.$route.query));
    this.tab = linkQuery.tab ? linkQuery.tab : "all";
    if (this.tab && this.tab !== "all") {
      const obj = this.selectorSpotTypes.find((x, index) => {
        if (x.id === this.tab) {
          x["index"] = index;
          return x;
        }
      });
      // this.changespotType(obj.id, obj.search, obj.index);
    }
    this.location = linkQuery.loc ? linkQuery.loc : "Worldwide";
    this.filterLocation = linkQuery.loc ? linkQuery.loc : "worldwide";
    this.spotTypes = linkQuery.st ? linkQuery.st : "all";
  },
  methods: {
    changespotType(optionId, spotType, index) {
      this.tab = optionId;
      if (optionId === "all") {
        this.spotTypes = spotType;
        this.searchFilter();
      } else {
        if (index > 0) {
          let currentOption = this.selectorSpotTypes[index];
          this.selectorSpotTypes.splice(index, 1);
          this.selectorSpotTypes.unshift(currentOption);
        }
        this.spotTypes = spotType;
        this.searchFilter();
      }
    },
    searchFilter() {
      localStorage.removeItem("homePageImages");
      const obj = {
        st: this.spotTypes,
        loc: this.location,
        filter: true,
        tab: this.tab,
      };
      let filterObject = {
        filtered: true,
        st: this.spotTypes,
        loc: this.location,
        tab: this.tab,
      };
      localStorage.setItem("filterSettings", JSON.stringify(filterObject));
      this.$router.push({ path: `/`, query: obj });
    },
    clearFilter() {
      localStorage.removeItem("homePageImages");
      this.tab = "all";
      this.spotTypes = ["all"];
      this.location = "worldwide";
      const obj = {
        st: ["all"],
        loc: "worldwide",
        filter: true,
        tab: "all",
      };
      let filterObject = {
        filtered: false,
        st: ["all"],
        loc: "worldwide",
        tab: this.tab,
      };
      localStorage.setItem("filterSettings", JSON.stringify(filterObject));
      this.$router.push({ path: `/`, query: obj });
    },
    setLocation(location) {
      this.filterLocation = location;
      this.location = location;
      this.openLocations = false;
      this.searchFilter();
    },
    toggleLocations() {
      this.openLocations = !this.openLocations;
    },
  },
};
</script>
<style scoped lang="scss">
//IMPORTED SEARCH CONTAINER SCSS FOR STYLES
@import "../../assets/scss/common/searchContainer";
</style>


// WEBPACK FOOTER //
// searchContainer.vue?1f8800c6